import { FormControl } from "@/Components/v2/atoms/FormControl";
import { MenuItem } from "@/Components/v2/atoms/MenuItem";
import { Select } from "@/Components/v2/atoms/Select";
import { Stack } from "@/Components/v2/atoms/Stack";
import { BoldSpan, Typography } from "@/Components/v2/atoms/Typography";

type ViewMode = {
  value: string;
  label: string;
  description?: string;
};

type ViewModeSelectorProps = {
  value: string;
  options: ViewMode[];
  onChange: (value: string) => void;
  width?: number;
  label?: string;
};

export const ViewModeSelector = ({
  value,
  options,
  onChange,
  width = 380,
  label = "View",
}: ViewModeSelectorProps) => {
  return (
    <FormControl size="small" sx={{ width }}>
      <Select
        value={value}
        onChange={(e) => onChange(e.target.value as string)}
        sx={{ minWidth: 200 }}
        renderValue={(value) => (
          <Typography fontSize={14}>
            <BoldSpan>{label}</BoldSpan>
            {`: ${options.find((option) => option.value === value)?.label}`}
          </Typography>
        )}
        MenuProps={{
          PaperProps: {
            sx: { width },
          },
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ py: 1 }}>
            <Stack direction="column">
              <Typography fontWeight={option.description ? 600 : 400} fontSize={14}>
                {option.label}
              </Typography>
              {option.description && (
                <Typography fontSize={12} whiteSpace="normal">
                  {option.description}
                </Typography>
              )}
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
